export default [
  'M27.6 33.7l-14-14.6V21l14-14.6c.5-.5.5-1.4 0-1.9s-1.4-.5-1.9 0l-14 14.6c-.5.5-.5 1.3 0 1.9l14 14.6c.5.5 1.4.6 1.9 0s.5-1.4 0-1.9z',
];
